import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import Logo from '@/assets/images/logo';

type FooterBottomSectionProps = {
    className?: string;
    address: string;
};

const FooterBottomSection = (props: FooterBottomSectionProps) => {
    const { className, address } = props;

    return (
        <div
            className={cn(
                'flex flex-wrap gap-4 justify-between items-center self-stretch flex-grow-0 flex-shrink-0 p-10 border-t border-r-0 border-b-0 border-l-0 border-[#b4b4b4]/[0.35]',
                className,
            )}
        >
            <div className="text-white flex flex-col justify-center items-start flex-grow-0 flex-shrink-0 relative gap-3">
                <Logo style="white" />
                <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative gap-1">
                    <svg
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M3.952 3.1934C4.464 3.2174 4.596 3.6534 4.604 3.8574H5.32C5.288 3.0654 4.724 2.5814 3.94 2.5814C3.056 2.5814 2.4 3.1374 2.4 4.3934C2.4 5.1694 2.772 6.0894 3.936 6.0894C4.824 6.0894 5.3 5.4294 5.312 4.9094H4.596C4.584 5.1454 4.416 5.4614 3.944 5.4854C3.42 5.4694 3.2 5.0614 3.2 4.3934C3.2 3.2374 3.712 3.2014 3.952 3.1934ZM4 0.337402C1.792 0.337402 0 2.1294 0 4.3374C0 6.5454 1.792 8.3374 4 8.3374C6.208 8.3374 8 6.5454 8 4.3374C8 2.1294 6.208 0.337402 4 0.337402ZM4 7.5374C2.236 7.5374 0.8 6.1014 0.8 4.3374C0.8 2.5734 2.236 1.1374 4 1.1374C5.764 1.1374 7.2 2.5734 7.2 4.3374C7.2 6.1014 5.764 7.5374 4 7.5374Z"
                            fill="currentColor"
                        />
                    </svg>
                    <p className="flex-grow-0 flex-shrink-0 text-[10px] text-left uppercase text-white">
                        Blockworks Inc.
                    </p>
                </div>
                <p className="flex-grow-0 flex-shrink-0 text-[10px] text-left uppercase text-white">{address}</p>
            </div>
            <div className="text-white flex justify-start items-start flex-grow-0 flex-shrink-0 relative gap-3">
                <a
                    href="https://twitter.com/Blockworks_"
                    target="_blank"
                    rel="noreferrer nofollow"
                    aria-label="Twitter"
                >
                    <svg
                        aria-hidden
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M20 8.3374C19.4 8.6374 18.8 8.7374 18.1 8.8374C18.8 8.4374 19.3 7.8374 19.5 7.0374C18.9 7.4374 18.2 7.6374 17.4 7.8374C16.8 7.2374 15.9 6.8374 15 6.8374C13.3 6.8374 11.8 8.3374 11.8 10.1374C11.8 10.4374 11.8 10.6374 11.9 10.8374C9.2 10.7374 6.7 9.4374 5.1 7.4374C4.8 7.9374 4.7 8.4374 4.7 9.1374C4.7 10.2374 5.3 11.2374 6.2 11.8374C5.7 11.8374 5.2 11.6374 4.7 11.4374C4.7 13.0374 5.8 14.3374 7.3 14.6374C7 14.7374 6.7 14.7374 6.4 14.7374C6.2 14.7374 6 14.7374 5.8 14.6374C6.2 15.9374 7.4 16.9374 8.9 16.9374C7.8 17.8374 6.4 18.3374 4.8 18.3374C4.5 18.3374 4.3 18.3374 4 18.3374C5.5 19.2374 7.2 19.8374 9 19.8374C15 19.8374 18.3 14.8374 18.3 10.5374C18.3 10.4374 18.3 10.2374 18.3 10.1374C19 9.6374 19.6 9.0374 20 8.3374Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://www.linkedin.com/company/the-blockworks-group"
                    target="_blank"
                    rel="noreferrer nofollow"
                    aria-label="Linkedin"
                >
                    <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M19.3 4.8374H4.7C4.3 4.8374 4 5.1374 4 5.5374V20.2374C4 20.5374 4.3 20.8374 4.7 20.8374H19.4C19.8 20.8374 20.1 20.5374 20.1 20.1374V5.5374C20 5.1374 19.7 4.8374 19.3 4.8374ZM8.7 18.4374H6.4V10.8374H8.8V18.4374H8.7ZM7.6 9.8374C6.8 9.8374 6.2 9.1374 6.2 8.4374C6.2 7.6374 6.8 7.0374 7.6 7.0374C8.4 7.0374 9 7.6374 9 8.4374C8.9 9.1374 8.3 9.8374 7.6 9.8374ZM17.6 18.4374H15.2V14.7374C15.2 13.8374 15.2 12.7374 14 12.7374C12.8 12.7374 12.6 13.7374 12.6 14.7374V18.5374H10.2V10.8374H12.5V11.8374C12.8 11.2374 13.6 10.6374 14.7 10.6374C17.1 10.6374 17.5 12.2374 17.5 14.2374V18.4374H17.6Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://t.me/blockworks_news"
                    target="_blank"
                    rel="noreferrer nofollow"
                    className="py-1"
                    aria-label="Telegram"
                >
                    <svg
                        aria-hidden
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.3158 0.996943C15.109 1.00765 14.9143 1.07457 14.7411 1.14952H14.7387C14.5632 1.22715 13.7289 1.61797 12.4618 2.20955C11.1947 2.80381 9.55008 3.57474 7.9175 4.34032C4.65716 5.8688 1.45212 7.37319 1.45212 7.37319L1.49059 7.35713C1.49059 7.35713 1.26938 7.43743 1.03856 7.6141C0.920749 7.69976 0.790912 7.81754 0.677906 8.00224C0.5649 8.18695 0.473533 8.47069 0.507195 8.76247C0.562496 9.25768 0.851022 9.55481 1.0578 9.7181C1.26698 9.88407 1.46654 9.96169 1.46654 9.96169H1.47135L4.47683 11.0886C4.61148 11.5705 5.3929 14.4293 5.58044 15.0879C5.69105 15.4813 5.79924 15.7276 5.93389 15.915C5.99881 16.0114 6.07575 16.0917 6.16711 16.1559C6.20318 16.18 6.24165 16.1987 6.28012 16.2148C6.29214 16.2228 6.30416 16.2255 6.31859 16.2282L6.28733 16.2202C6.29695 16.2228 6.30416 16.2309 6.31138 16.2335C6.33542 16.2416 6.35225 16.2442 6.38351 16.2496C6.85957 16.4102 7.24187 16.081 7.24187 16.081L7.26351 16.0622L9.03795 14.2634L12.0122 16.8037L12.0795 16.8358C12.6998 17.1383 13.3274 16.9697 13.6592 16.6725C13.9934 16.3727 14.1232 15.9899 14.1232 15.9899L14.1449 15.9284L16.4434 2.81987C16.5084 2.49598 16.5252 2.19349 16.4531 1.89904C16.3809 1.60459 16.1958 1.32887 15.9722 1.18165C15.7462 1.03174 15.5226 0.986236 15.3158 0.996943ZM15.2533 2.40229C15.2509 2.44512 15.2581 2.43976 15.2413 2.52274V2.53077L12.9643 15.5028C12.9547 15.5215 12.9379 15.5617 12.8922 15.6018C12.8441 15.6446 12.8056 15.6714 12.6061 15.5831L8.96822 12.4779L6.77061 14.7077L7.23225 11.4259C7.23225 11.4259 12.9306 5.51278 13.1759 5.25848C13.4211 5.00418 13.3394 4.95064 13.3394 4.95064C13.3562 4.64013 12.9691 4.85963 12.9691 4.85963L5.47465 10.0286L5.47225 10.0152L1.8801 8.66878V8.6661C1.87769 8.6661 1.87288 8.66343 1.87048 8.66343C1.87288 8.66343 1.88972 8.65539 1.88972 8.65539L1.90895 8.64469L1.92819 8.63666C1.92819 8.63666 5.13563 7.13227 8.39598 5.60379C10.0286 4.83821 11.6732 4.06728 12.9379 3.47302C14.2026 2.88144 15.1379 2.44779 15.1908 2.4237C15.2413 2.40229 15.2172 2.40229 15.2533 2.40229Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://www.instagram.com/blockworks__/"
                    target="_blank"
                    rel="noreferrer nofollow"
                    aria-label="Instagram"
                >
                    <span className="sr-only">Instagram</span>
                    <svg
                        aria-hidden
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M16.145 9.6894C15.6148 9.6894 15.185 9.2596 15.185 8.7294C15.185 8.19921 15.6148 7.7694 16.145 7.7694C16.6752 7.7694 17.105 8.19921 17.105 8.7294C17.105 9.2596 16.6752 9.6894 16.145 9.6894ZM12 16.8374C9.794 16.8374 8 15.0434 8 12.8374C8 10.6314 9.794 8.8374 12 8.8374C14.206 8.8374 16 10.6314 16 12.8374C16 15.0434 14.206 16.8374 12 16.8374ZM12 10.8374C10.897 10.8374 10 11.7344 10 12.8374C10 13.9404 10.897 14.8374 12 14.8374C13.103 14.8374 14 13.9404 14 12.8374C14 11.7344 13.103 10.8374 12 10.8374ZM16 20.8374H8C5.944 20.8374 4 18.8934 4 16.8374V8.8374C4 6.7814 5.944 4.8374 8 4.8374H16C18.056 4.8374 20 6.7814 20 8.8374V16.8374C20 18.8934 18.056 20.8374 16 20.8374ZM8 6.8374C7.065 6.8374 6 7.9024 6 8.8374V16.8374C6 17.7904 7.047 18.8374 8 18.8374H16C16.935 18.8374 18 17.7724 18 16.8374V8.8374C18 7.9024 16.935 6.8374 16 6.8374H8Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://discord.com/invite/aU7UkQQCR5"
                    target="_blank"
                    rel="noreferrer nofollow"
                    aria-label="Discord"
                >
                    <svg
                        aria-hidden
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M18.9308 6.47889C17.6561 5.89399 16.2892 5.46306 14.8599 5.21625C14.8339 5.21148 14.8079 5.22339 14.7945 5.24719C14.6187 5.55987 14.4239 5.96779 14.2876 6.28841C12.7503 6.05827 11.221 6.05827 9.71527 6.28841C9.57887 5.96066 9.37707 5.55987 9.20048 5.24719C9.18707 5.22418 9.16107 5.21228 9.13504 5.21625C7.70659 5.46227 6.33963 5.8932 5.06411 6.47889C5.05307 6.48365 5.04361 6.49159 5.03732 6.5019C2.44449 10.3755 1.73421 14.154 2.08265 17.8855C2.08423 17.9038 2.09447 17.9213 2.10867 17.9324C3.81934 19.1886 5.47642 19.9513 7.10273 20.4568C7.12876 20.4648 7.15634 20.4553 7.1729 20.4338C7.55761 19.9085 7.90054 19.3545 8.19456 18.772C8.21192 18.7379 8.19535 18.6974 8.15989 18.6839C7.61594 18.4776 7.098 18.226 6.59977 17.9403C6.56037 17.9173 6.55721 17.8609 6.59347 17.8339C6.69831 17.7554 6.80318 17.6736 6.9033 17.5911C6.92141 17.576 6.94665 17.5728 6.96794 17.5824C10.2411 19.0767 13.7846 19.0767 17.0191 17.5824C17.0404 17.572 17.0657 17.5752 17.0846 17.5903C17.1847 17.6728 17.2895 17.7554 17.3952 17.8339C17.4314 17.8609 17.4291 17.9173 17.3897 17.9403C16.8914 18.2315 16.3735 18.4776 15.8288 18.6831C15.7933 18.6966 15.7775 18.7379 15.7949 18.772C16.0952 19.3537 16.4381 19.9076 16.8157 20.433C16.8315 20.4553 16.8599 20.4648 16.8859 20.4568C18.5201 19.9513 20.1772 19.1886 21.8879 17.9324C21.9028 17.9213 21.9123 17.9046 21.9139 17.8863C22.3309 13.5722 21.2154 9.82477 18.9568 6.50269C18.9513 6.49159 18.9419 6.48365 18.9308 6.47889ZM8.68335 15.6134C7.69792 15.6134 6.88594 14.7087 6.88594 13.5976C6.88594 12.4865 7.68217 11.5818 8.68335 11.5818C9.69239 11.5818 10.4965 12.4945 10.4807 13.5976C10.4807 14.7087 9.68451 15.6134 8.68335 15.6134ZM15.329 15.6134C14.3435 15.6134 13.5316 14.7087 13.5316 13.5976C13.5316 12.4865 14.3278 11.5818 15.329 11.5818C16.338 11.5818 17.1421 12.4945 17.1264 13.5976C17.1264 14.7087 16.338 15.6134 15.329 15.6134Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://www.tiktok.com/@blockworks__"
                    target="_blank"
                    rel="noreferrer nofollow"
                    className="py-1"
                    aria-label="Tiktok"
                >
                    <svg
                        aria-hidden
                        width="16"
                        height="16"
                        viewBox="0 0 512 512"
                        id="icons"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="https://www.youtube.com/channel/UCkrwgzhIBKccuDsi_SvZtnQ"
                    target="_blank"
                    rel="noreferrer nofollow"
                    aria-label="Youtube Channel"
                >
                    <svg
                        aria-hidden
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            d="M20.775 8.9874C20.55 7.5249 19.875 6.5124 18.3 6.2874C15.825 5.8374 12 5.8374 12 5.8374C12 5.8374 8.175 5.8374 5.7 6.2874C4.125 6.5124 3.3375 7.5249 3.225 8.9874C3 10.4499 3 12.5874 3 12.5874C3 12.5874 3 14.7249 3.225 16.1874C3.45 17.6499 4.125 18.6624 5.7 18.8874C8.175 19.3374 12 19.3374 12 19.3374C12 19.3374 15.825 19.3374 18.3 18.8874C19.875 18.5499 20.55 17.6499 20.775 16.1874C21 14.7249 21 12.5874 21 12.5874C21 12.5874 21 10.4499 20.775 8.9874ZM9.75 15.9624V9.2124L15.375 12.5874L9.75 15.9624Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default FooterBottomSection;
